import type { SpartanProductExteriorThreesixtyDragCursorTone } from '@/app/lcv/components/sections/spartan/products/exterior/threesixty/viewer/drag-cursor/types';
import type { SpartanProductExteriorStyleName } from '@/app/lcv/components/sections/spartan/products/exterior/types';
import { cnva } from '@/app/utils/cnva';

export type { SpartanProductExteriorThreesixtyDragCursorTone };

/** Map product exterior `styleName` to the 360° drag-cursor tone. */
export const getSpartanProductExteriorThreesixtyDragCursorTone = (
  styleName: SpartanProductExteriorStyleName
): SpartanProductExteriorThreesixtyDragCursorTone => {
  if (styleName === 'mu-x' || styleName === 'mu-x-elegant') return 'lime';
  if (styleName === 'mu-x-ultimate' || styleName === 'mu-x-active') {
    return 'mist';
  }
  if (
    styleName === 'v-cross' ||
    styleName === 'pick-up-2-door' ||
    styleName === 'pick-up-4-door'
  ) {
    return 'red';
  }

  return 'default';
};

export const SpartanProductExteriorThreesixtyDragCursorSurfaceStyled = cnva(
  [
    'flex size-20 origin-center -translate-x-1/2 -translate-y-1/2 items-center justify-center gap-2 rounded-full transition-[opacity,scale] duration-200 ease-linear will-change-[opacity,scale] motion-reduce:scale-100 motion-reduce:transition-opacity motion-reduce:duration-100 md:size-23',
  ],
  {
    variants: {
      tone: {
        default: 'bg-white/50 text-gray-900 backdrop-blur-md',
        red: 'bg-red-500 text-white',
        lime: 'bg-[#96da05] text-gray-900',
        mist: 'bg-[#d0dfe3] text-gray-900',
      },
      isVisible: {
        true: 'scale-100 opacity-100',
        false: 'scale-0 opacity-0',
      },
    },
    defaultVariants: {
      tone: 'default',
      isVisible: false,
    },
  }
);
